import { ButtonDropdownMenu, IButtonDropdownMenuProps } from '@color/continuum';
import { IColorUser, getFullName, useAuthContext } from '@color/lib';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

interface Props extends Omit<IButtonDropdownMenuProps, 'dropdownButtonProps'> {
  participant?: IColorUser;
}

export const UserDropdownMenu: React.FC<Props> = (props) => {
  const { participant, dropdownItems, dropdownId } = props;
  const { currentUser } = useAuthContext();

  const colorUser = participant || currentUser;

  return (
    <ButtonDropdownMenu
      dropdownId={dropdownId}
      dropdownButtonProps={{
        variant: 'text',
        color: 'secondary',
        content: (
          <>
            {colorUser && getFullName(colorUser)}
            <ExpandMoreIcon />
          </>
        ),
      }}
      dropdownItems={dropdownItems}
    />
  );
};
